import { render, staticRenderFns } from "./ClassificacoesLista.vue?vue&type=template&id=0fe4d711&scoped=true&"
import script from "./ClassificacoesLista.vue?vue&type=script&lang=js&"
export * from "./ClassificacoesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4d711",
  null
  
)

export default component.exports